
document.addEventListener("click", function () {
  // 0.5 saniye bekleme
  setTimeout(() => {
    const step1Items = document.querySelector("#step1-items");
    const stepWrap = document.querySelector(".step-wrap.step-second");

    if (step1Items && step1Items.children.length > 0) {
      // Eğer içerik varsa, 'step-1-done' sınıfını ekle
      stepWrap.classList.add("step-1-done");
    } else {
      // Eğer içerik yoksa, 'step-1-done' sınıfını kaldır
      stepWrap.classList.remove("step-1-done");
    }
  }, 500); // Yarım saniye bekleme
});
document.addEventListener("click", function () {
  // 0.5 saniye bekleme
  setTimeout(() => {
    const step1Items = document.querySelector("#step1-items");
    const step2Items = document.querySelector("#step2-items");
    const selectCartButton = document.querySelector("#select-cart");
    const addToCart = document.querySelector("#add-to-cart");

    // Her iki liste de boşsa, buton tıklanamaz olsun
    if (
      (step1Items && step1Items.children.length === 0) ||
      (step2Items && step2Items.children.length === 0)
    ) {
      selectCartButton.disabled = true; // Butonu tıklanamaz yap
      addToCart.disabled = true; // Butonu tıklanamaz yap
    } else {
      selectCartButton.disabled = false; // Butonu aktif yap
      addToCart.disabled = false; // Butonu aktif yap
    }
  }, 500); // Yarım saniye bekleme
});

// .right-side-opener öğesine tıklama (veya dokunma) durumu
document
  .querySelector(".right-side-opener")
  .addEventListener("click", function () {
    // .kendi-kutunu-yap-wrapper .right öğesine 'mobile open' sınıflarını ekle
    const rightWrapper = document.querySelector(
      ".kendi-kutunu-yap-wrapper .right"
    );
    if (rightWrapper) {
      rightWrapper.classList.add("open");
    }
  });

// #kart-alani veya #close-side öğelerine tıklama durumunda
document
  .querySelectorAll("#kart-alani, #close-side, .close-side")
  .forEach((element) => {
    element.addEventListener("click", function () {
      // .kendi-kutunu-yap-wrapper .right öğesinden 'mobile open' sınıflarını kaldır
      const rightWrapper = document.querySelector(
        ".kendi-kutunu-yap-wrapper .right"
      );
      if (rightWrapper) {
        rightWrapper.classList.remove("open");
      }
    });
  });
// .kendi-kutunu-yap-wrapper .right öğesini seç
const rightWrapper = document.querySelector(".kendi-kutunu-yap-wrapper .right");

// MutationObserver ile değişiklikleri izle

const observer = new MutationObserver(function (mutationsList) {
  mutationsList.forEach(function (mutation) {
    // Eğer içerikte değişiklik olduysa, 'open' sınıfını ekle
    /*if (mutation.type === "childList" && rightWrapper) {
      rightWrapper.classList.add("open");
    }*/
  });
});

// İzlenecek elementler (step1-items, step2-items, step3-items)
const steps = ["#step1-items", "#step2-items", "#step3-items"];

// Observer için her bir step öğesini izle
steps.forEach((stepId) => {
  const stepElement = document.querySelector(stepId);
  if (stepElement) {
    observer.observe(stepElement, { childList: true, subtree: true });
  }
});
document.addEventListener("click", function () {
  setTimeout(function () {
    let total = 0; // Her tıklamada total sıfırlanır

    // .selected-items içindeki tüm .product-each-price spanlarını seç
    const priceElements = document.querySelectorAll(
      ".selected-items .product-each-price"
    );

    priceElements.forEach((span) => {
      // Span içindeki sayıyı al, " TL" kısmını kaldır, ve sayıya çevir
      const priceText = span.textContent.replace(" TL", "").trim();
      const price = parseFloat(priceText);

      // Eğer price geçerli bir sayı ise total'e ekle
      if (!isNaN(price)) {
        total += price;
      }
    });

    // Toplamı #total-price-value-original id'li span içine yazdır
    document.getElementById("total-price-value-original").textContent =
      total.toFixed(2) + " TL";
  }, 500); // 500 milisaniye gecikme
});
/*
document.querySelector("#select-cart").addEventListener("click", function () {
  // .step-wrap.step-third öğesine 'active' sınıfı ekle
  const stepThird = document.querySelector(".step-wrap.step-third");
  if (stepThird) {
    stepThird.classList.add("active");
  }

  // #kart-alani öğesine kaydır
  const kartAlani = document.querySelector("#kart-alani");
  if (kartAlani) {
    kartAlani.scrollIntoView({ behavior: "smooth" }); // Yumuşak kaydırma
  }
});
*/

/**/
document.addEventListener("DOMContentLoaded", function () {
  // Delegated: İncele butonuna tıklanınca detailed-view'e active sınıfı ekle
  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest(".model-2[open-box], .light-box-oprn-all");
    if (!openBtn) return;
    
    const item = openBtn.closest(".product-list-item");
    if (!item) return;
    
    const detailedView = item.querySelector(".detailed-view");
    if (!detailedView) return;
    
    detailedView.classList.add("active");

    // İlk gösterilecek resim ayarı
    const productImageDiv = detailedView.querySelector(".product-image");
    const variantSelector = detailedView.querySelector(".variant-selector");
    if (variantSelector && productImageDiv) {
      const initialVariantId = variantSelector.value;
      updateProductImage(productImageDiv, initialVariantId);
    }
  });

  // Delegated: Variant seçici değiştiğinde imajı güncelle
  document.addEventListener("change", function (e) {
    const selector = e.target.closest(".variant-selector");
    if (!selector) return;
    
    const dv = selector.closest(".detailed-view");
    if (!dv) return;
    
    const productImageDiv = dv.querySelector(".product-image");
    if (!productImageDiv) return;
    
    const selectedVariantId = selector.value;
    updateProductImage(productImageDiv, selectedVariantId);
  });

  // Delegated: Kişiselleştirme metni girilince ilgili Ekle butonunu etkinleştir/devre dışı bırak
  document.addEventListener("input", function (e) {
    const input = e.target.closest(".custom-text");
    if (!input) return;
    
    const handle = input.getAttribute("data-product-handle");
    if (!handle) return;
    
    const scope = input.closest(".detailed-view, .details, .light-box-details");
    if (!scope) return;
    
    const button = scope.querySelector(`.ekle-ve-kapa[data-handle="${handle}"]`);
    if (!button) return;
    
    const bosMessage = scope.querySelector(".bos-message");
    
    if (input.value.trim() !== "") {
      button.disabled = false;
      if (bosMessage) {
        bosMessage.style.display = "none";
      }
    } else {
      button.disabled = true;
      if (bosMessage) {
        bosMessage.style.display = "block";
      }
    }
  });

  // Kişiselleştirme input'u olmayan butonları enabled yap (sayfa yüklendiğinde ve yeni ürünler eklendiğinde)
  function enableButtonsWithoutCustomInputs() {
    document.querySelectorAll(".ekle-ve-kapa, .select-product-step-1, .select-product-step-2").forEach((button) => {
      const handle = button.getAttribute("data-handle");
      if (!handle) return;
      
      // Butonun bulunduğu container'ı bul - önce product-list-item, sonra details
      const productItem = button.closest(".product-list-item");
      const container = productItem || button.closest(".detailed-view, .details");
      if (!container) return;
      
      // Bu ürün için kişiselleştirme input'u var mı kontrol et
      // Hem lightbox içinde hem de direkt butonlar için kontrol et
      const hasCustomTextInput = container.querySelector(`input.custom-text[data-product-handle="${handle}"], input#${handle}-urun-uzerindeki-yazi, input#${handle}-urun-uzerindeki-harf`);
      
      // Eğer kişiselleştirme input'u yoksa VE buton disabled ise, enabled yap
      if (!hasCustomTextInput && button.disabled) {
        button.disabled = false;
      }
    });
  }

  // Sayfa yüklendiğinde çalıştır
  setTimeout(enableButtonsWithoutCustomInputs, 100);

  // Yeni ürünler eklendiğinde de çalıştır (MutationObserver ile)
  const productsObserver = new MutationObserver(function(mutations) {
    // Sadece gerçekten yeni ürün eklendiğinde çalıştır (debounce)
    clearTimeout(productsObserver.timeout);
    productsObserver.timeout = setTimeout(enableButtonsWithoutCustomInputs, 100);
  });

  // Products list area'ları izle
  document.querySelectorAll(".products-list-area, .hediye-product-list").forEach((area) => {
    productsObserver.observe(area, { childList: true, subtree: true });
  });

  // Delegated: Ekle ve kapat butonu tıklanınca lightbox kapansın
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".ekle-ve-kapa");
    if (!btn) return;
    
    if (btn.disabled) {
      e.preventDefault();
      return;
    }

    const detailedView = btn.closest(".detailed-view");
    if (detailedView) {
      detailedView.classList.remove("active");
    }
  });

  // Seçilen varyanta göre ürün görselini güncelle
  function updateProductImage(productImageDiv, variantId) {
    if (!productImageDiv || !variantId) return;
    
    const item = productImageDiv.closest(".product-list-item");
    if (!item) return;
    
    const variantSelector = item.querySelector(".variant-selector");
    if (!variantSelector) return;
    
    const productHandle = variantSelector.getAttribute("data-handle");
    if (!productHandle) return;
    
    fetch(window.location.origin + `/products/${productHandle}.js`)
      .then((response) => {
        if (!response.ok) throw new Error("Ürün verisi alınamadı.");
        return response.json();
      })
      .then((data) => {
        const selectedVariant = data.variants.find(
          (variant) => variant.id == variantId
        );
        if (selectedVariant && selectedVariant.featured_image) {
          productImageDiv.innerHTML = `<img src="${selectedVariant.featured_image.src}" alt="${data.title}" class="variant-image">`;
        }
      })
      .catch((error) => {
        console.error("Varyant görseli yüklenirken hata oluştu:", error);
      });
  }

  // Delegated: Lightbox kapatma butonu
  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest(".detailed-view .close");
    if (!closeBtn) return;
    
    const detailedView = closeBtn.closest(".detailed-view");
    if (detailedView) {
      detailedView.classList.remove("active");
    }
  });
});
